import { BackendGrade, Grade, mapBackendGradeToGrade } from './Grade';

export type SchoolSubject = {
  id: string;
  name: string;
  shortCode: string;
  description: string;
  grade?: Grade;
};

export type BackendSchoolSubject = {
  id: string;
  name: string;
  shortcode: string;
  description: string;
  grade?: {
    data: BackendGrade;
  };
};

// MAPPER

export const mapBackendSchoolSubjectToSchoolSubject = (
  backendSchoolSubject: BackendSchoolSubject
): SchoolSubject => ({
  id: backendSchoolSubject.id,
  name: backendSchoolSubject.name,
  description: backendSchoolSubject.description,
  shortCode: backendSchoolSubject.shortcode,
  grade: backendSchoolSubject.grade
    ? mapBackendGradeToGrade(backendSchoolSubject.grade.data)
    : undefined,
});

export const getSchoolSubjectsMapper = (response: any): SchoolSubject[] =>
  response.data
    .map(mapBackendSchoolSubjectToSchoolSubject)
    .sort((a: SchoolSubject, b: SchoolSubject) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
